module.exports = __webpack_public_path__ + "img/ic-chev-e-light.9f78269e.svg";